export const withPayloadType = <T>() => (t: T) => ({payload: t});
export const getter = (obj: any, prop: string) => obj[prop];
export const setter = (obj: any, prop: string, value: any) => {
  obj[prop] = value;
};
